import { render } from "./MyCardsView.vue?vue&type=template&id=7be1488a&scoped=true"
import script from "./MyCardsView.vue?vue&type=script&lang=js"
export * from "./MyCardsView.vue?vue&type=script&lang=js"

import "./MyCardsView.vue?vue&type=style&index=0&id=7be1488a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be1488a"]])

export default __exports__